'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAmountByCurrency = exports.getConvertedAmountList = exports.getConvertedAmounts = exports.getBaseAmount = undefined;

var _createSelector = require('./utils/createSelector');

var _createSelector2 = _interopRequireDefault(_createSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Base Getters
// ------------------------------------------

var getBaseAmount = exports.getBaseAmount = function getBaseAmount(amount) {
    return amount ? amount.amount : undefined;
};
var getConvertedAmounts = exports.getConvertedAmounts = function getConvertedAmounts(amount) {
    return amount ? amount.convertedAmounts : undefined;
};
var getConvertedAmountList = exports.getConvertedAmountList = function getConvertedAmountList(amount) {
    return amount ? amount.convertedAmountList : undefined;
};

// Selectors
// ------------------------------------------

/**
 * @param {object} Item
 * @returns {function} A function that can take a currency and return the value amount as long as
 *                      amount is inflated (so amount and convertedAmounts are present)
 */
var getAmountByCurrency = exports.getAmountByCurrency = (0, _createSelector2.default)(getBaseAmount, getConvertedAmounts, getConvertedAmountList, function (baseAmount, convertedAmounts, convertedAmountList) {
    return function (currency) {
        if (baseAmount === 0) {
            return 0;
        } else if (convertedAmounts) {
            return convertedAmounts[currency];
        } else if (convertedAmountList) {
            return getBaseAmount(convertedAmountList.find(function (amount) {
                return amount.currency === currency;
            }));
        } else {
            return undefined;
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./~/dibs-display-helpers/~/dibs-selectors/dist/amount.js
// module id = 1218
// module chunks = 4 5 12